module.exports = __webpack_public_path__ + "img/pic_boat.ce965bed.png";